/** @format */

import React, { Component } from 'react';
import { DropzoneArea } from 'material-ui-dropzone';
import I18n from '../../components/Translate/I18n';
import CustomButtom from '../../components/CustomButtons/ButtonExt';

class DropzoneAreaExt extends Component {
    constructor(props) {
        super(props);
        this.state = {
            file: null,
        };
    }

    handleUpload = () => {
        this.props.uploadCallback(this.state.file);
    };

    handleUploadFiles = (file) => {
        this.setState({
            file: file,
        });
    };

    render() {
        return (
            <div>
                <DropzoneArea
                    dropzoneText=""
                    onChange={this.handleUploadFiles}
                    onDrop={this.handleUploadFiles}
                    maxFileSize={process.env.REACT_APP_UPLOAD_MAX_FILE_SIZE}
                    filesLimit={1}
                    acceptedFiles={[
                        'application/csv',
                        'application/x-csv',
                        'text/csv',
                        'text/comma-separated-values',
                        'text/x-comma-separated-values',
                        'text/tab-separated-values',
                    ]}
                />
                <CustomButtom type="button" onClick={this.handleUpload}>
                    <I18n trans="general:common.upload" />
                </CustomButtom>
            </div>
        );
    }
}

export default DropzoneAreaExt;
